<div class="header flex justify-content-between align-items-center">
  <div class="flex align-items-center gap-2 pl-2">
    <p-button
      rounded
      text
      styleClass="text-white md:hidden block"
      icon="pi pi-bars"
      [style]="{ height: '35px', width: '35px' }"
      [ariaLabel]="'Άνοιγμα μενού'"
      (onClick)="showSideMenu.emit(true)"
    />
    <img
      class="logo"
      src="./assets/icons/logo_top.png"
      alt="Λογότυπο ΕΟΠΥΥ"
      (click)="onLogoClick()"
    />
    <div>
      <h3 class="text-0">
        <ng-container *ngIf="innerWidth != 0 && innerWidth > 1180">
          {{ environment.appTitle }}
          <div>
            <small class="font-light">
              {{ environment.appSubtitle }}
            </small>
          </div>
        </ng-container>
        <ng-container *ngIf="innerWidth != 0 && innerWidth <= 1180">
          {{ environment.appTitleShort }}
        </ng-container>
      </h3>
      <small *ngIf="isStageEnvironment && innerWidth <= 600">
        ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
      </small>
    </div>
  </div>
  <div class="flex align-items-center mr-2">
    <!--<h4 class="staging-header" *ngIf="isStageEnvironment">ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ</h4>-->
    <div
      class="flex justify-content-center gap-2"
      style="min-width: 280px"
      *ngIf="isStageEnvironment && innerWidth > 600"
    >
      <p-message severity="warn" text="ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ" />
    </div>
    <p-splitButton
      text
      label="asd"
      [model]="userMenuItems"
      [menuButtonProps]="{ ariaLabel: 'Μενού χρήστη' }"
      (onClick)="onUserButtonClick()"
    >
      <ng-template pTemplate="content">
        <span class="flex items-center font-bold text-0">
          <i class="pi pi-user mr-2"></i>
          <span>{{ innerWidth > 800 ? getNameAndRole() : "" }}</span>
        </span>
      </ng-template>
      <ng-template pTemplate="dropdownicon">
        <i class="pi pi-chevron-down text-0"></i>
      </ng-template>
    </p-splitButton>
  </div>
</div>
<!-- <hr class="shadow-1" /> -->
<app-user-change-password-form #passwordForm></app-user-change-password-form>
